<template>
  <div class="img">
    <img src="/static/img/strength_intro/home_banner.png"/>
  </div>

</template>

<script>
  export default{
    name: 'homeBanner'
  }
</script>

<style scoped>
  .img {
    /*height: 599px;*/
    height: auto;
    width: auto;
    margin: 0;
    padding: 0;
    display: flex;
  }

  div.container {
    padding: 0;
    margin: auto;
    width: auto;
  }

  span {
    width: auto;
    font-weight: 700;
    font-style: normal;
    font-family: 'Helvetica-Bold', 'Helvetica Bold', 'Helvetica';
    background-color: rgba(215, 215, 215, 1);
    font-size: 32px;
    white-space: nowrap;
    color: #333333;
  }

  div.line {
    margin-left: 12%;
  }

  img {
    width: 100%;
    height: 100%;
    /*width: 1100px;*/
    /*height: 360px;*/
  }

</style>



// WEBPACK FOOTER //
// HomeBanner.vue?7b175522